import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=9c7dc820&scoped=true&"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashboardView.vue?vue&type=style&index=0&id=9c7dc820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7dc820",
  null
  
)

export default component.exports